// extracted by mini-css-extract-plugin
module.exports = {"page":"pricing_page__aR2vI","balance":"pricing_balance__42hd9","focusLink":"pricing_focusLink__Jp9jH","faq":"pricing_faq__Hq1Bv","faqPlus":"pricing_faqPlus__Jz6d0"};